// routes.js


import ComHome from './components/home/com/ComHome.vue';
import VadHome from './components/home/vad/VadHome.vue';
import TlvHome from './components/home/tlv/TlvHome.vue';
import PartnerHome from './components/home/partner/PartnerHome.vue';
import ZoneGeo from './components/ZoneGeo.vue';
import ChoixCategorieOffre from './components/souscription/ChoixCategorieOffre.vue';
import BarCodeReader from './components/souscription/BarCodeReader.vue';
import OffresBox from './components/souscription/offresbox/OffresBox.vue';
import Adresse from './components/souscription/offresbox/eligibilite/adresse/Adresse.vue';
import Carto from './components/souscription/offresbox/eligibilite/carto/Carto.vue';
import ChoixOffreOption from './components/souscription/offresbox/eligibilite/choixoffreoption/ChoixOffreOption.vue';
import ChoixOffreOptionMobile from './components/souscription/offresmobile/choixoffreoption/ChoixOffreOption.vue';
import AdrTech from './components/souscription/offresbox/eligibilite/adrtech/AdrTech.vue';
import ResultElig from './components/souscription/offresbox/eligibilite/resultat/Resultat.vue';
import QrcodeScan from './components/souscription/qrcode/qrcodescan/QrcodeScan.vue';
import QrcodeSign from './components/souscription/qrcode/qrcodesign/QrcodeSign.vue';
import Qrcode from './components/souscription/qrcode/qrcode/Qrcode.vue';
import ProgressScan from './components/souscription/progress/progressscan/ProgressScan.vue';
import ProgressSign from './components/souscription/progress/progresssign/ProgressSign.vue';
import ScanDocuments from './components/souscription/scandocuments/ScanDocuments.vue';
import RecapScanOk from './components/souscription/recapscan/recapok/RecapOk.vue';
import RecapScanOkForToken from './components/souscription/recapscan/recapokfortoken/RecapOkForToken.vue';
import RecapScanError from './components/souscription/recapscan/recaperror/RecapError.vue';
import RecapScanWarning from './components/souscription/recapscan/recapwarning/RecapWarning.vue';
import Signature from './components/souscription/signature/Signature.vue';
import RecapSignOk from './components/souscription/recapsign/recapok/RecapOk.vue';
import RecapSignOkForToken from './components/souscription/recapsign/recapokfortoken/RecapOkForToken.vue';
import RecapSignError from './components/souscription/recapsign/recaperror/RecapError.vue';
import RecapSignAutprev from './components/souscription/recapsign/recapautprev/RecapAutprev.vue';
import Recap from './components/souscription/recap/Recap.vue';
import RecapMobile from './components/souscription/offresmobile/recap/Recap.vue';
import Cgv from './components/souscription/cgv/Cgv.vue';
import UpdatePassword from './components/UpdatePassword.vue';
import VadListe from './components/adminvad/VadListe.vue';
import PendingList from './components/souscription/pending/PendingList.vue';
import PortaFixe from './components/souscription/offresbox/portabilite/Portabilite.vue';
import PortaMobile from './components/souscription/offresmobile/portabilite/Portabilite.vue';
import Contact from './components/souscription/offresbox/contact/Contact.vue';
import ContactMobile from './components/souscription/offresmobile/contact/Contact.vue';
import DejaClient from './components/souscription/offresbox/DejaClient.vue';
import RdvCreneaux from './components/souscription/offresbox/rdv/creneaux/Creneaux.vue';
import RdvConf from './components/souscription/offresbox/rdv/confirmation/Confirmation.vue';
import Final from './components/souscription/final/Final.vue';

const routes = [
   { path: '/com', name:"ComHome",component: ComHome },
   { path: '/vad', name:"VadHome", component: VadHome },
   { path: '/tlv', name:"TlvHome", component: TlvHome },
   { path: '/partner', name:"PartnerHome", component: PartnerHome },
   { path: '/zonegeo', component: ZoneGeo },
   { path: '/souscription/choixcategorieoffre', name:'ChoixCategorieOffre',component: ChoixCategorieOffre },
   { path: '/souscription/barcodereader', name:'BarCodeReader',component: BarCodeReader },
   { path: '/souscription/offresbox', name:'OffreBox', component: OffresBox },
   { path: '/souscription/offresbox/eligibilite/adresse', name:'Adresse', component: Adresse },
   { path: '/souscription/offresbox/eligibilite/carto', name:'Carto', component: Carto },
   { path: '/souscription/offresbox/eligibilite/choixoffreoption', name:'ChoixOffreOption', component: ChoixOffreOption },
   { path: '/souscription/offresmobile/choixoffreoption', name:'ChoixOffreOptionMobile', component: ChoixOffreOptionMobile },
   { path: '/souscription/offresbox/eligibilite/adrtech', name:'AdrTech', component: AdrTech },
   { path: '/souscription/offresbox/eligibilite/resultelig', name:'ResultElig', component: ResultElig },
   { path: '/souscription/offresbox/portabilite', name:'PortaFixe', component: PortaFixe },
   { path: '/souscription/offresmobile/portabilite', name:'PortaMobile', component: PortaMobile },
   { path: '/souscription/offresbox/contact', name:'Contact', component: Contact },
   { path: '/souscription/offresmobile/contact', name:'ContactMobile', component: ContactMobile },
   { path: '/souscription/offresbox/dejaclient', name:'DejaClient', component: DejaClient },
   { path: '/souscription/qrcode/qrcodescan', name:'QrcodeScan', component: QrcodeScan },
   { path: '/souscription/qrcode/qrcodesign', name:'QrcodeSign', component: QrcodeSign },
   { path: '/souscription/qrcode/qrcode', name:'Qrcode', component: Qrcode },
   { path: '/souscription/progress/progressscan', name:'ProgressScan', component: ProgressScan },
   { path: '/souscription/progress/progresssign', name:'ProgressSign', component: ProgressSign },
   { path: '/souscription/scandocuments', name:'ScanDocuments', component: ScanDocuments },
   { path: '/souscription/recap', name:'Recap',component: Recap },
   { path: '/souscription/offresmobile/recap', name:'RecapMobile',component: RecapMobile },
   { path: '/souscription/cgv', name:'Cgv', component: Cgv, props: true },
   { path: '/souscription/recapscanok', name:'RecapScanOk',component: RecapScanOk },
   { path: '/souscription/recapscanokfortoken', name:'RecapScanOkForToken',component: RecapScanOkForToken },
   { path: '/souscription/recapscanerror', name:'RecapScanError',component: RecapScanError },
   { path: '/souscription/recapscanwarning', name:'RecapScanWarning',component: RecapScanWarning },
   { path: '/souscription/signature', name:'Signature',component: Signature },
   { path: '/souscription/recapsignok', name:'RecapSignOk',component: RecapSignOk },
   { path: '/souscription/recapsignokfortoken', name:'RecapSignOkForToken',component: RecapSignOkForToken },
   { path: '/souscription/recapsignerror', name:'RecapSignError',component: RecapSignError },
   { path: '/souscription/recapsignautprev', name:'RecapSignAutprev',component: RecapSignAutprev },
   { path: '/modificationmotdepasse', name:'UpdatePassword',component: UpdatePassword },
   { path: '/listevadeurs', name:'VadListe',component: VadListe },
   { path: '/pendingList', name:'PendingList',component: PendingList },
   { path: '/souscription/offresbox/rdv/creneaux', name:'RdvCreneaux', component: RdvCreneaux },
   { path: '/souscription/offresbox/rdv/confirmation', name:'RdvConfirmation', component: RdvConf },
   { path: '/souscription/final', name:'Final', component: Final }
];

export default routes;